export interface PositionValues {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}
export interface PositionData {
  top?: string | null;
  right?: string | null;
  bottom?: string | null;
  left?: string | null;
  values: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
    centerVertical: number;
    centerHorizontal: number;
  };
  boundingClientRect: DOMRect;
}

export class PositionUtil {

  public static _getReturnObject(pos: { top?: number, right?: number, bottom?: number, left?: number }, elementRect: DOMRect):
    PositionData {
    return {
      top: pos.top ? pos.top + 'px' : null,
      right: pos.right ? pos.right + 'px' : null,
      bottom: pos.bottom ? pos.bottom + 'px' : null,
      left: pos.left ? pos.left + 'px' : null,
      values: {
        ...pos,
        centerVertical: elementRect.y + elementRect.height / 2,
        centerHorizontal: elementRect.x + elementRect.width / 2
      },
      boundingClientRect: elementRect
    };
  }
  getModalPosition(element: HTMLElement, position: 'right' | 'left' | 'bottom' | 'top'): PositionData | null {
    const elementRect = element.getBoundingClientRect();
    let left, right, top;
    switch (position) {
      case 'right':
        left = elementRect.x + elementRect.width;
        return PositionUtil._getReturnObject({top: elementRect.top, left}, elementRect);
      case 'left':
        right = window.innerWidth - elementRect.x;
        return PositionUtil._getReturnObject({top: elementRect.top, right}, elementRect);
      case 'bottom':
        top = elementRect.y + elementRect.height;
        return PositionUtil._getReturnObject({top, left: elementRect.left}, elementRect);
    }
    return null;
  }
  getPositionData(element: HTMLElement): PositionData {
    return PositionUtil._getReturnObject({}, element.getBoundingClientRect());
  }

  /**
   * returns the css value for the top position in PX
   * @param top - the wanted top position
   * @param paddingTop - the padding from the top of the screen
   */
  getTopPosition(top: number, paddingTop: number): string {
    if (top < paddingTop) {
      return paddingTop + 'px';
    }
    return top + 'px';
  }
  getLeftPosition(left: number, paddingTop: number, element: HTMLElement): string {
    const rect = element.getBoundingClientRect();
    if (window.innerWidth - left + rect.width < paddingTop) {
      return window.innerWidth - paddingTop - rect.width + 'px';
    }
    return left + 'px';
  }


  getOptimalPosition(defaultPos: PositionValues, padding: number | PositionValues) {
    const _padding: PositionValues = typeof padding === 'number' ? {top: padding, left: padding, right: padding, bottom: padding} : padding;
    const newPos: PositionValues = {};
    if (defaultPos.top) {
      newPos.top = _padding.top && defaultPos.top > _padding.top ? defaultPos.top : _padding.top;
    }
    if (defaultPos.right) {
      newPos.right = !!_padding.right && defaultPos.right > _padding.right ? defaultPos.right : _padding.right;
    }

  }
}
